/* eslint-disable object-curly-newline */
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useMemo } from 'react';
import { SELECT_DATE } from 'common/constants/inputs';
import { CustomSelect, withTooltip } from 'components';
import { useLedgerContext } from 'context/LedgerContext';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { InvestmentDateSelectProps } from 'pages/CapTable/fund-ownership/components/InvestmentDateSelect.props';

const InvestmentDateSelect = ({ cell, investmentDates = [] }: InvestmentDateSelectProps) => {
  const { onCellsChange } = useLedgerContext();

  const handleChange = (value: string | null) => {
    onCellsChange([{ cell: cell as ICell, value }]);
  };

  const getOptions = useMemo(() => {
    const tmpOptions: { value: string; label: string }[] = [];

    if (Array.isArray(investmentDates)) {
      investmentDates.forEach(date => {
        tmpOptions.push({
          value: date,
          label: date,
        });
      });
    }

    return tmpOptions;
  }, [investmentDates]);

  return (
    <CustomSelect
      id={`investment-date-${cell?.key}`}
      value={(cell?.value as string) || ''}
      options={getOptions}
      openMenuOnFocus={false}
      onChange={handleChange}
      onEmptyValue={SELECT_DATE}
      disabled={cell?.readOnly}
      setLabelAsValue
      autoFocus={false}
    />
  );
};

export default withTooltip(InvestmentDateSelect);
